var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1638 0.129641C11.3682 -0.0558328 11.6842 -0.0404107 11.8699 0.163821C12.0554 0.368159 12.0399 0.684211 11.8357 0.869876L6.3357 5.86988C6.14508 6.0429 5.85444 6.0429 5.66382 5.86988L0.163821 0.869876C-0.0404107 0.684211 -0.0558328 0.368159 0.129641 0.163821C0.315306 -0.0404107 0.631358 -0.0558328 0.835696 0.129641L5.99976 4.82398L11.1638 0.129641Z",
    fill: "#586370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown-arrow.b3dbb87007ec846f5d23e106ea1b60bc.svg";
export { ForwardRef as ReactComponent };